import { render } from "./CompanyName.vue?vue&type=template&id=103d588d&scoped=true"
import script from "./CompanyName.vue?vue&type=script&lang=ts"
export * from "./CompanyName.vue?vue&type=script&lang=ts"

import "./CompanyName.vue?vue&type=style&index=0&id=103d588d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-103d588d"

export default script